<template>
<div>
<svg id="closemodalredBigRed2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44.11 44.11"><defs></defs><title>Asset 1</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><polygon class="cls-1closeModalRed2" points="44.11 38.71 27.46 22.05 44.11 5.4 38.71 0 22.05 16.65 5.4 0 0 5.4 16.65 22.05 0 38.71 5.4 44.11 22.05 27.46 38.71 44.11 44.11 38.71"/></g></g></svg>
</div>
</template>



<script>
export default{

    
}



</script>


<style>

.cls-1closeModalRed2{fill: #F05D5B;}

.cls-1{fill:#F05D5B;}.cls-2{fill:#fff;}


svg#closemodalredBigRed2{
    width:30px;
    margin: 10px auto;
}

</style>